export default "__VITE_ASSET__BtXQY_eQ__"